import { render, staticRenderFns } from "./select-tags.vue?vue&type=template&id=e349f912&scoped=true"
import script from "./select-tags.vue?vue&type=script&lang=js"
export * from "./select-tags.vue?vue&type=script&lang=js"
import style0 from "./select-tags.vue?vue&type=style&index=0&id=e349f912&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e349f912",
  null
  
)

export default component.exports